<style>
.page-item{
        cursor:pointer;
}
</style>

<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                 <h3 class="card-title">Daftar Penyedia</h3>
            </div>  
        </div>

        <!--<div class="row">
            <div class="col-12" style="padding-bottom:10px;">
                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Penyedia
                </button>
            </div>
        </div>-->

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                 Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data

                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th role='button' v-on:click="sortRecords('id')">ID</th>
                      <th role='button' v-on:click="sortRecords('nama')">Nama</th>
                      <th role='button' v-on:click="sortRecords('npwp')">NPWP</th>
                      <!--th>Created</th-->
                      <!--<th>Action</th>-->
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="penyedia in penyedias.data" :key="penyedia.id">

                      <td>{{penyedia.id}}</td>
                      <td class="text-capitalize">{{penyedia.nama}}</td>
                      <td>{{penyedia.npwp}}</td>
                      <!--td>{{penyedia.created_at}}</td-->
                      <!--<td>

                        <a href="#" @click="editModal(penyedia)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                      </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                <div class="row">                  
                        <div class="col-12">
                            <pagination :records="parseInt(penyedias.total)" v-model="page" :per-page="perPage" :options="{texts: { count: 'Menampilkan data ke {from} sampai {to} dari total {count} data|{count} records|One record' }}" @paginate="getResults"></pagination>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-12">
                                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                        </div>
                    </div>                  
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Penyedia</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Penyedia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updatePenyedia() : createPenyedia()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Penyedia</label>
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                            <has-error :form="form" field="nama"></has-error>
                        </div>
                        <div class="form-group">
                            <label>NPWP</label>
                            <input v-model="form.npwp" type="text" name="npwp" @keyup="angka"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('npwp') }">
                            <has-error :form="form" field="npwp"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Pagination from 'vue-pagination-2';

    export default {
         components: {
            Pagination
        },
        data () {
            return {
                editmode: false,
                searchTerm:'',
                penyedias : {},
                form: new Form({
                    id : '',
                    nama: '',
                    npwp: '',
                }),
                sortIndex: 'nama',
                sortDirection: 'asc',
                perPage:10,
                showTable:'penyedia',
                page: 1
            }
        },
        methods: {
            sortRecords (index) {
               
                this.sortIndex = index;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                  
                this.page = 1;
                  
                axios.get('/api/penyedia?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage).then(({ data }) => (this.penyedias = data.data));

                this.$Progress.finish();
            },    
            changePageRange(){
                this.$Progress.start();
                  this.page = 1;

                  axios.get('/api/penyedia?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage).then(({ data }) => (this.penyedias = data.data));

                  this.$Progress.finish();
            },
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/penyedia?page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage).then(({ data }) => (this.penyedias = data.data));

                  this.$Progress.finish();
            },
            updatePenyedia(){
                this.$Progress.start();
                this.form.put('/api/penyedia/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadPenyedias();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(penyedia){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(penyedia);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadPenyedias(){
                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                if(this.$gate.isAdmin1()){
                    axios.get("/api/penyedia?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage).then(({ data }) => (this.penyedias = data.data));
                }
                //axios.get("/api/penyedia?search=" + param).then(({ data }) => (this.penyedias = data.data));
            },
            
            createPenyedia(){

                this.form.post('/api/penyedia')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadPenyedias();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            },
			angka() {
                if (!/^[0-9]+$/.test(this.form.npwp)) {
                    this.form.npwp = this.form.npwp.substring(0,this.form.npwp.length-1);
                }
            },

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadPenyedias();
            this.$Progress.finish();
        },
        watch: {
            searchTerm: function() {
                this.loadPenyedias();
            }
        }
    }
</script>